<script setup lang="ts">
const {
  size = "md",
  link,
  color = "light",
} = defineProps<{
  size?: "sm" | "md";
  color?: "dark" | "light";
  link: {
    url?: string;
    externalLinkUrl?: string;
    opensInNewTab: boolean;
    slug?: string;
    title: string;
    [key: string]: any; // allow any other properties from contentful
  };
}>();

const emit = defineEmits(["click"]);

const localePath = useLocalePath();

const to = computed(() => {
  if (link.externalLinkUrl) {
    return link.externalLinkUrl;
  }

  if (link?.slug || link?.link?.fields?.slug) {
    const slug = link.slug || link.link?.fields?.slug;

    return localePath(slug.startsWith("/") ? slug : `/${slug}`);
  }

  return link.url || link.link?.fields?.url;
});
</script>

<template>
  <NuxtLink
    exact-active-class="footer-link--active"
    active-class="footer-link--active"
    :target="link.opensInNewTab ? '_blank' : '_self'"
    :class="[
      'footer-link',
      { 'footer-link--sm': size === 'sm' },
      `footer-link--${color}`,
    ]"
    :to="to"
    @click.native="emit('click')"
    >{{ link.title }}
    <Icon
      class="footer-link__icon"
      v-if="link.externalLinkUrl"
      name="citizenm:external-link"
    />
  </NuxtLink>
</template>

<style scoped lang="scss">
.footer-link {
  display: inline-block;
  color: var(--primary-white, #fff);
  font-size: 1rem;
  font-family: var(--font-family, sans-serif);
  line-height: 1.5rem;
  text-decoration: none;

  &__icon {
    font-size: 0.75rem;
    line-height: 2.5rem;
  }

  &--sm {
    font-size: 0.75rem;
    text-decoration: underline;
  }

  &--dark {
    color: var(--primary-black, #000);
  }

  &:hover {
    color: var(--primary-red, #ff0038);
  }
}
</style>
